var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"279aef2be20454d36a1fcb842ec1ec4746cd9e1c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hirefly-web-client@hirefly"]={id:"279aef2be20454d36a1fcb842ec1ec4746cd9e1c"};
      